import React from 'react';
import classnames from 'classnames';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import TopBar from '../TopBar';
import NavBar from '../NavBar';
import LocaleSelector from '../../core/LocaleSelector';
import PopupWindowContainer from '../PopupWindowContainer';
import {useGlobalContext} from '../../core/GlobalContext';
import ButtonAction from '../ButtonAction';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../enums';
import styles from './PageContainer.module.scss';

const PageContainer = () => {
  const {
    layoutDirection,
    pageTitle,
    showPopupPanel,
    goBackToOldApp,
    showGoBackToOldAppButton,
    supportMeteor
  } = useGlobalContext();

  const navigate = useNavigate();
  const goHome = () => navigate(P.HOME);
  const location = useLocation();
  const hideBackButtonLocations = [
    P.AUTH,
    P.LOGOUT,
    P.LOGIN,
    P.LOGIN_BY_PHONE,
    P.LOGIN_AS_ADMIN,
    P.FORGOT_PASSWORD,
    P.UPDATE_PASSWORD,
    P.REGISTER,
    P.HOME
  ];
  const hideBackButton = hideBackButtonLocations.includes(location.pathname)
    || location.pathname.includes('/paypalPaymentStatus');

  return (
    <div
      className={styles.pageContainer}
      dir={layoutDirection}
    >
      <TopBar/>
      <div className={classnames(styles.innerContainer, styles.background)}>
        <div className={styles.asideContainer}>
          <div className={styles.buttonHeaderContainer}>
            {(showGoBackToOldAppButton && !hideBackButton) && (
              <ButtonAction
                variant={'link'}
                label={
                  <FormattedMessage
                    id={'button-label-back-to-user-page'}
                    defaultMessage={'Return'}
                  />
                }
                customClassnames={{label: styles.backButton}}
                onClick={goBackToOldApp}
              />
            )}
            {(!supportMeteor && !hideBackButton) && (
              <ButtonAction
                variant={'link'}
                label={
                  <FormattedMessage
                    id={'button-label-back-to-user-page'}
                    defaultMessage={'Return'}
                  />
                }
                customClassnames={{label: styles.backButton}}
                onClick={goHome}
              />
            )}
            {pageTitle}
          </div>
          <NavBar/>
          <div className={styles.localeSelector}>
            <LocaleSelector/>
          </div>
        </div>

        <div className={classnames(styles.contentBackground, {[styles.lessMargin]: showPopupPanel})}>
          <div className={styles.contentContainer}>
            <Outlet/>
          </div>
        </div>

        {showPopupPanel && <PopupWindowContainer/>}
      </div>
    </div>
  );
};

export default PageContainer;
